import { testimonials } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

export default function TestimonialsSection() {
  return (
    <section id="voices" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100/60">
      <SectionHeading
        eyebrow="大家怎么说"
        title="来自瓜田里的真实声音"
        desc="他们有的蹲了半年，有的刚来没几天。共同点是：现在吃瓜，终于吃得明白了。"
        align="center"
      />

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col p-6 rounded-lg bg-background-50 border border-background-200"
          >
            <div className="flex items-center gap-0.5 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`${
                    i < item.rating ? "ri-star-fill" : "ri-star-line"
                  } w-4 h-4 flex items-center justify-center`}
                ></i>
              ))}
            </div>
            <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">
              “{item.text}”
            </blockquote>
            <figcaption className="mt-5 pt-5 border-t border-background-200 flex items-center gap-3">
              <span className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.avatar}
                  alt={`${item.name} 的头像`}
                  title={`${item.name} 在诱惑吃瓜的发言`}
                  className="w-full h-full object-cover"
                />
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                <p className="text-xs text-foreground-500">{item.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}